import { render, staticRenderFns } from "./posChainModal.vue?vue&type=template&id=79f94ce4&scoped=true&"
import script from "./posChainModal.vue?vue&type=script&lang=js&"
export * from "./posChainModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f94ce4",
  null
  
)

export default component.exports